import { unlink as unlink_1 } from './unlink.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';

import { removeLink } from 'roosterjs-editor-api';

const unlink: RibbonButton = {
    key: 'unlink',
    title: () => loc(unlink_1),
    imageSrc: require('../svg/unlink.svg'),
    buttonState: formatState =>
        formatState.canUnlink ? RibbonButtonState.Normal : RibbonButtonState.Disabled,
    onExecute: plugin => removeLink(plugin.getEditor()),
};

export default unlink;
